<app-top-menu></app-top-menu>

<div class="container">
    <div class="bg-white rounded-2 p-4" style="margin: 10% auto">

        <div style="width: 100% !important;padding: 50px 0">
            <div class="d-flex justify-content-center">

                <div class="pdf-box-bg m-2">
                    <img class="me-3" src="assets/support-resource/tax-act.svg" alt="" />
                    <div class="d-flex flex-column align-self-center">
                        <h6 class="mb-1">Anambra State Revenue Law</h6>
                        <a style="width: fit-content;" (click)="download('assets/PDFs/Anambra_State_Revenue_Law.pdf')" href="javascript:void(0)"
                           download="Anambra_State_Revenue_Law.pdf"
                        > <!--/app/Module/Navigation/support-resources/PDFs/Anambra_State_Revenue_Law.pdf-->
                            <img src="assets/support-resource/tax-download.svg" alt="" />
                        </a>
                    </div>
                </div>

                <div class="pdf-box-bg m-2">
                    <img class="me-3" src="assets/support-resource/tax-act.svg" alt="" />
                    <div class="d-flex flex-column align-self-center">
                        <h6 class="mb-1">APLUC Law</h6>
                        <a style="width: fit-content;" (click)="download('assets/PDFs/APLUC_Law.pdf')" href="javascript:void(0)">
                            <img src="assets/support-resource/tax-download.svg" alt="" />
                        </a>
                    </div>
                </div>

                <div class="pdf-box-bg m-2">
                    <img class="me-3" src="assets/support-resource/tax-act.svg" alt="" />
                    <div class="d-flex flex-column align-self-center">
                        <h6 class="mb-1">ASWAMA Law Gazette</h6>
                        <a style="width: fit-content;" (click)="download('assets/PDFs/ASWAMA_Law_Gazette.pdf')" href="javascript:void(0)">
                            <img src="assets/support-resource/tax-download.svg" alt="" />
                        </a>
                    </div>
                </div>
            </div>

            <div class="d-flex justify-content-center">
                <div class="pdf-box-bg m-2">
                    <img class="me-3" src="assets/support-resource/tax-act.svg" alt="" />
                    <div class="d-flex flex-column align-self-center">
                        <h6 class="mb-1">Business Premises law</h6>
                        <a style="width: fit-content;" (click)="download('assets/PDFs/Business_Premesis_law.pdf')" href="javascript:void(0)">
                            <img src="assets/support-resource/tax-download.svg" alt="" />
                        </a>
                    </div>
                </div>

                <div class="pdf-box-bg m-2">
                    <img class="me-3" src="assets/support-resource/tax-act.svg" alt="" />
                    <div class="d-flex flex-column align-self-center">
                        <h6 class="mb-1">Capital Gains Tax Act</h6>
                        <a style="width: fit-content;" (click)="download('assets/PDFs/Capital_Gains_Tax_Act_1.pdf')" href="javascript:void(0)">
                            <img src="assets/support-resource/tax-download.svg" alt="" />
                        </a>
                    </div>
                </div>

                <div class="pdf-box-bg m-2">
                    <img class="me-3" src="assets/support-resource/tax-act.svg" alt="" />
                    <div class="d-flex flex-column align-self-center">
                        <h6 class="mb-1">Finance Act 2020</h6>
                        <a style="width: fit-content;" (click)="download('assets/PDFs/Finance_Act_2020.pdf')" href="javascript:void(0)">
                            <img src="assets/support-resource/tax-download.svg" alt="" />
                        </a>
                    </div>
                </div>
            </div>

            <div class="d-flex justify-content-center">
                <div class="pdf-box-bg m-2">
                    <img class="me-3" src="assets/support-resource/tax-act.svg" alt="" />
                    <div class="d-flex flex-column align-self-center">
                        <h6 class="mb-1">PITA Amendment</h6>
                        <a style="width: fit-content;" (click)="download('assets/PDFs/PITA_Ammendment.pdf')" href="javascript:void(0)">
                            <img src="assets/support-resource/tax-download.svg" alt="" />
                        </a>
                    </div>
                </div>

                <div class="pdf-box-bg m-2">
                    <img class="me-3" src="assets/support-resource/tax-act.svg" alt="" />
                    <div class="d-flex flex-column align-self-center">
                        <h6 class="mb-1">Stamp Duty Act</h6>
                        <a style="width: fit-content;" (click)="download('assets/PDFs/Stamduty_Act.pdf')" href="javascript:void(0)">
                            <img src="assets/support-resource/tax-download.svg" alt="" />
                        </a>
                    </div>
                </div>

                <div class="pdf-box-bg m-2">
                    <img class="me-3" src="assets/support-resource/tax-act.svg" alt="" />
                    <div class="d-flex flex-column align-self-center">
                        <h6 class="mb-1">Taxes And Levies Act</h6>
                        <a style="width: fit-content;" (click)="download('assets/PDFs/Taxes_and_Levies_Act.pdf')" href="javascript:void(0)">
                            <img src="assets/support-resource/tax-download.svg" alt="" />
                        </a>
                    </div>
                </div>
            </div>
        </div>

    </div>
</div>

<app-footer></app-footer>
